import { ArdoqIconCategory, getShapesByCategory } from '@ardoq/icons';
import { Select } from './Select';
import { ShapeIconOption } from './ShapeIconOption';
import { SelectProps } from '../types';

const getShapeOptionsByCategory = (
  ardoqIconCategory: ArdoqIconCategory,
  color?: string
) =>
  getShapesByCategory(ardoqIconCategory).map(({ id, label }) => ({
    value: id,
    label: label,
    leftContent: <ShapeIconOption shapeId={id} color={color} />,
  }));

type ComponentShapeSelectProps = Omit<SelectProps<string>, 'options'> & {
  color?: string;
};

export const ComponentShapeSelect = ({
  color,
  ...selectProps
}: ComponentShapeSelectProps) => (
  <Select
    {...selectProps}
    options={[
      {
        label: 'Ardoq',
        options: getShapeOptionsByCategory(ArdoqIconCategory.Ardoq, color),
      },
      {
        label: 'ArchiMate',
        options: getShapeOptionsByCategory(ArdoqIconCategory.ArchiMate, color),
      },
      {
        label: 'BPMN',
        options: getShapeOptionsByCategory(ArdoqIconCategory.BPMN, color),
      },
      {
        label: 'EDGY',
        options: getShapeOptionsByCategory(ArdoqIconCategory.EDGY, color),
      },
    ]}
  />
);
